import { render, staticRenderFns } from "./SummaryPlacedSimple.vue?vue&type=template&id=535f423c&"
import script from "./SummaryPlacedSimple.js?vue&type=script&lang=js&"
export * from "./SummaryPlacedSimple.js?vue&type=script&lang=js&"
import style0 from "./SummaryPlacedSimple.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports